// extracted by mini-css-extract-plugin
module.exports = {"DocumentFormModal":"DocumentsFormModal_DocumentFormModal__kFd7U","Accordion":"DocumentsFormModal_Accordion__1P7_m"};